import { EmptyArticle } from './emptyArticle.model';
import { BasePlanningItem } from './basePlanningItem.model';

export class EmptyPlanningItem extends BasePlanningItem {
    constructor() {
        super(new EmptyArticle(), true);
    }
}
